import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import PropTypes from '../../lib/utils/propTypes';

const InputWithLabel = ({ label, labelProps, innerRef, name, ...inputProps }) => (
	<FormGroup>
		<Label
			{...labelProps}
			className={inputProps.required ? 'required' : ''}
			for={inputProps.id}
		>
			{label}
		</Label>
		<Input
			name={name}
			{...inputProps}
			innerRef={innerRef({ required: inputProps.required })}
		/>
	</FormGroup>
);


InputWithLabel.propTypes = {
	label: PropTypes.string.isRequired,
	labelProps: PropTypes.shape({}),
};

InputWithLabel.defaultProps = {
	labelProps: {},
};

export default InputWithLabel;